import {
  VpAudioMethods,
  VpBaseMethods,
  VpMovieClipMethods,
  VpDragonBoneMethods,
  VpParticleMethods,
  VpTweenMethods,
  VpVideoMethods,
  VpDrawLineMethods,
  VpEraseMethods,
} from '@ps/bridge/qc/vp/config'
import maskAction from './mask'
import carouselAction from './carousel'
const VpCategories = {
  animation: {
    single: '单个动画',
    all: '全部动画',
  },
  movieClip: '序列帧',
  dragonBone: '龙骨',
  particle: '粒子特效',
  basic: {
    switchAndAction: '跳转及埋点',
    node: '图层',
    timer: '计时器',
    event: '事件',
    bgm: '背景音乐',
  },
  audio: '音效',
  video: '视频',
  drawLine: '连线组件',
  freeDrawLine: '自由画线组件',
  erase: '擦除组件',
  mask: '遮罩组件',
  carousel: '轮播组件',
  other: '其他',
}

export default {
  // 一些组件配置是动态生成的，且带了文本配置，这里配置这些动态生成的组件的国际化配置便于后续加工处理
  component: {
    switch: {
      'active-text': '启用',
      'inactive-text': '禁用',
    },
  },
  action: {
    [VpTweenMethods.vpPlayTweenByUuid]: {
      label: '播放单个动画',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: '选择动画',
        },
      },
    },
    [VpTweenMethods.vpStopTweenByUuid]: {
      label: '暂停播放单个动画',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: '选择动画',
        },
      },
    },
    [VpTweenMethods.vpPlayTweenByUuidGoOn]: {
      label: '继续播放单个动画',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: '选择动画',
        },
      },
    },
    [VpTweenMethods.vpResetTweenPropByUuid]: {
      label: '返回单个动画初始状态',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: '选择动画',
        },
      },
    },
    [VpTweenMethods.vpPlayTween]: {
      label: '从头播放全部动画',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpPlayTweenGoOn]: {
      label: '继续播放全部动画',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpStopTween]: {
      label: '暂停播放全部动画',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpResetTweenProp]: {
      label: '返回全部动画初始状态',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpPlayTweenChildrenAll]: {
      label: '播放分组的全部动画',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpStopTweenChildrenAll]: {
      label: '暂停播放分组的全部动画',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpPlayTweenChildrenAllGoOn]: {
      label: '继续播放分组的全部动画',
      category: VpCategories.animation.all,
    },
    [VpMovieClipMethods.vpPlayMC]: {
      label: '显示并播放序列帧',
      category: VpCategories.movieClip,
      paramFormConfig: {
        loop: {
          title: '无限循环',
        },
        hideWhenFinished: {
          title: '播放完后是否隐藏',
        },
        pingpong: {
          title: '来回播放',
        },
        playTime: {
          title: '播放次数',
        },
      },
    },
    [VpMovieClipMethods.vpStopMC]: {
      label: '暂停序列帧',
      category: VpCategories.movieClip,
    },
    [VpDragonBoneMethods.vpPlaySKPlayer]: {
      label: '播放龙骨',
      category: VpCategories.dragonBone,
      paramFormConfig: {
        animationName: {
          title: '动作名字',
        },
        loop: {
          title: '循环',
        },
        speed: {
          title: '速度',
        },
      },
    },
    [VpDragonBoneMethods.vpStopSKPlayer]: {
      label: '暂停龙骨',
      category: VpCategories.dragonBone,
    },
    [VpParticleMethods.vpPlayParticle]: {
      label: '显示并播放粒子特效',
      category: VpCategories.particle,
    },
    [VpParticleMethods.vpStopParticle]: {
      label: '暂停播放粒子特效',
      category: VpCategories.particle,
    },
    [VpParticleMethods.vpClearParticle]: {
      label: '清除粒子特效',
      category: VpCategories.particle,
    },
    [VpParticleMethods.vpParticleStartColor]: {
      label: '粒子出生颜色',
      category: VpCategories.particle,
      paramFormConfig: {
        startColor: {
          title: '粒子出生颜色',
        },
      },
    },
    [VpBaseMethods.vpSwitchScene]: {
      label: '跳转指定场景',
      category: VpCategories.basic.switchAndAction,
      paramFormConfig: {
        jumpSceneId: {
          title: '跳转的场景',
        },
      },
    },
    [VpBaseMethods.vpSwitchNextScene]: {
      label: '跳转到下一场景',
      category: VpCategories.basic.switchAndAction,
    },
    [VpBaseMethods.vpInstall]: {
      label: '跳转应用商店',
      category: VpCategories.basic.switchAndAction,
    },
    [VpBaseMethods.vpGameEnd]: {
      label: '上报试玩结束',
      category: VpCategories.basic.switchAndAction,
    },
    [VpBaseMethods.vpSendAction]: {
      label: '设置埋点',
      category: VpCategories.basic.switchAndAction,
      paramFormConfig: {
        action_id: {
          title: '埋点id',
        },
        action_name: {
          title: '埋点名称',
        },
      },
    },
    [VpBaseMethods.vpPosition]: {
      label: '设置位置',
      category: VpCategories.basic.node,
      paramFormConfig: {
        position: {
          title: '位置',
        },
      },
    },
    [VpBaseMethods.vpScaleXY]: {
      label: '设置缩放',
      category: VpCategories.basic.node,
      paramFormConfig: {
        scale: {
          title: '缩放比例',
        },
      },
    },
    [VpBaseMethods.vpRotate]: {
      label: '设置旋转',
      category: VpCategories.basic.node,
      paramFormConfig: {
        rotation: {
          title: '旋转角度',
        },
      },
    },
    [VpBaseMethods.vpWidth]: {
      label: '设置宽度',
      category: VpCategories.basic.node,
      paramFormConfig: {
        width: {
          title: '设置宽度',
        },
      },
    },
    [VpBaseMethods.vpHeight]: {
      label: '设置高度',
      category: VpCategories.basic.node,
      paramFormConfig: {
        height: {
          title: '设置高度',
        },
      },
    },
    [VpBaseMethods.vpShowHide]: {
      label: '显示/隐藏图层',
      category: VpCategories.basic.node,
      paramFormConfig: {
        isShow: {
          title: '显示/隐藏',
          field: {
            options: [
              {
                label: '显示',
              },
              {
                label: '隐藏',
              },
            ],
          },
        },
      },
    },
    [VpBaseMethods.vpAlpha]: {
      label: '设置透明度',
      category: VpCategories.basic.node,
      paramFormConfig: {
        alpha: {
          title: '设置透明度',
        },
      },
    },
    [VpBaseMethods.vpColor]: {
      label: '设置颜色',
      category: VpCategories.basic.node,
      paramFormConfig: {
        color: {
          title: '设置颜色',
        },
      },
    },
    [VpBaseMethods.vpWaitTime]: {
      label: '执行延迟',
      category: VpCategories.basic.timer,
      paramFormConfig: {
        ms: {
          title: '延迟时长',
        },
        timerId: {
          title: '定时器名称',
        },
        lastTimerId: {
          title: '',
        },
      },
    },
    [VpBaseMethods.vpClearTime]: {
      label: '取消执行延迟',
      category: VpCategories.basic.timer,
      paramFormConfig: {
        timerId: {
          title: '定时器ID',
        },
      },
    },
    [VpBaseMethods.enabledEvent]: {
      label: '禁用/启用事件',
      category: VpCategories.basic.event,
      paramFormConfig: {
        eventId: {
          title: '事件',
        },
        enabled: {
          title: '禁用/启用',
        },
      },
    },
    [VpBaseMethods.enabledEventActive]: {
      label: '启用事件',
      category: VpCategories.basic.event,
      paramFormConfig: {
        eventId: {
          title: '事件',
        },
      },
    },
    [VpBaseMethods.enabledEventBan]: {
      label: '禁用事件',
      category: VpCategories.basic.event,
      paramFormConfig: {
        eventId: {
          title: '事件',
        },
      },
    },
    [VpBaseMethods.vpPlayBgm]: {
      label: '播放背景音乐',
      category: VpCategories.basic.bgm,
    },
    [VpBaseMethods.vpReplayBgm]: {
      label: '从头播放背景音乐',
      category: VpCategories.basic.bgm,
    },
    [VpBaseMethods.vpResumeBgm]: {
      label: '继续播放背景音乐',
      category: VpCategories.basic.bgm,
    },
    [VpBaseMethods.vpStopBgm]: {
      label: '暂停播放背景音乐',
      category: VpCategories.basic.bgm,
    },
    [VpAudioMethods.vpPlaySound]: {
      label: '播放音效',
      category: VpCategories.audio,
      paramFormConfig: {
        isStop: {
          title: '是否从头播放',
        },
        loop: {
          title: '无限循环',
        },
        loopNumber: {
          title: '播放次数',
        },
      },
    },
    [VpAudioMethods.vpReplaySound]: {
      label: '从头播放音效',
      category: VpCategories.audio,
      paramFormConfig: {
        loop: {
          title: '无限循环',
        },
        loopNumber: {
          title: '播放次数',
        },
        isStopSound: {
          title: '触发时停止播放上一次触发的音效',
        },
      },
    },
    [VpAudioMethods.vpResumeSound]: {
      label: '继续播放音效',
      category: VpCategories.audio,
    },
    [VpAudioMethods.vpStopSound]: {
      label: '暂停播放音效',
      category: VpCategories.audio,
      paramFormConfig: {
        isStop: {
          title: '是否暂停当前场景全部音效',
        },
      },
    },
    [VpVideoMethods.vpPlayVideo]: {
      label: '播放视频',
      category: VpCategories.video,
      paramFormConfig: {
        loopNumber: {
          title: '播放次数',
        },
        loop: {
          title: '无限循环',
        },
        playEndFrame: {
          title: '保持尾帧',
        },
      },
    },
    [VpVideoMethods.vpReplayVideo]: {
      label: '从头播放视频',
      category: VpCategories.video,
      paramFormConfig: {
        loopNumber: {
          title: '播放次数',
        },
        loop: {
          title: '无限循环',
        },
        playEndFrame: {
          title: '保持尾帧',
        },
      },
    },
    [VpVideoMethods.vpResumeVideo]: {
      label: '继续播放视频',
      category: VpCategories.video,
    },
    [VpVideoMethods.vpStopVideo]: {
      label: '暂停播放视频',
      category: VpCategories.video,
    },
    [VpVideoMethods.vpPauseVideo]: {
      label: '暂停播放视频',
      category: VpCategories.video,
    },
    [VpDrawLineMethods.vpEraseLine]: {
      label: '抹除连线线条',
      category: VpCategories.drawLine,
      paramFormConfig: {
        pair: {
          title: '抹除对象',
        },
      },
    },
    [VpDrawLineMethods.vpModifyLineStyle]: {
      label: '修改连线线条样式',
      category: VpCategories.drawLine,
      paramFormConfig: {
        area: {
          title: '起止区域',
        },
        lineColor: {
          title: '线条颜色',
        },
        lineStyle: {
          title: '线条粗细',
        },
      },
    },
    [VpDrawLineMethods.vpEnablePair]: {
      label: '启用/禁用配对关系',
      category: VpCategories.drawLine,
      paramFormConfig: {
        pair: {
          title: '配对关系',
        },
        enableBan: {
          title: '启用/禁用',
          field: {
            options: [
              {
                label: '启用',
              },
              {
                label: '禁用',
              },
            ],
          },
        },
      },
    },
    [VpDrawLineMethods.vpModifyPairLineStyle]: {
      label: '修改已连线配对的线条样式',
      category: VpCategories.drawLine,
      paramFormConfig: {
        pair: {
          title: '配对关系',
        },
        lineColor: {
          title: '线条颜色',
        },
        lineStyle: {
          title: '线条粗细',
        },
      },
    },
    [VpDrawLineMethods.vpEnableBanArea]: {
      label: '启用/禁用起止区域',
      category: VpCategories.drawLine,
      paramFormConfig: {
        area: {
          title: '起止区域',
        },
        enableBan: {
          title: '启用/禁用',
          field: {
            options: [
              {
                label: '启用',
              },
              {
                label: '禁用',
              },
            ],
          },
        },
      },
    },
    [VpDrawLineMethods.vpFreeEraseLine]: {
      label: '抹除画线线条',
      category: VpCategories.freeDrawLine,
    },
    [VpDrawLineMethods.vpFreeModifyLineStyle]: {
      label: '修改画线线条样式',
      category: VpCategories.freeDrawLine,
      paramFormConfig: {
        lineColor: {
          title: '线条颜色',
        },
        lineStyle: {
          title: '线条粗细',
        },
      },
    },
    [VpDrawLineMethods.vpFreeEnable]: {
      label: '启用/禁用自由画线组件',
      category: VpCategories.freeDrawLine,
      paramFormConfig: {
        enableBan: {
          title: '启用/禁用',
          field: {
            options: [
              {
                label: '启用',
              },
              {
                label: '禁用',
              },
            ],
          },
        },
      },
    },
    [VpDrawLineMethods.vpFreeEnableRigidBody]: {
      label: '已画线条生成刚体',
      category: VpCategories.freeDrawLine,
    },
    [VpEraseMethods.vpEnableEraseComponent]: {
      label: '启用/禁用擦除组件',
      category: VpCategories.erase,
      paramFormConfig: {
        isEnable: {
          title: '启用/禁用',
          field: {
            options: [
              {
                label: '启用',
              },
              {
                label: '禁用',
              },
            ],
          },
        },
      },
    },
    [VpEraseMethods.vpEraseTrace]: {
      label: '清除擦除痕迹',
      category: VpCategories.erase,
      paramFormConfig: {},
    },
    [VpEraseMethods.vpShowGroup]: {
      label: '显示/隐藏分组',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
        },
        isShow: {
          title: '显示/隐藏',
          field: {
            options: [
              {
                label: '显示',
              },
              {
                label: '隐藏',
              },
            ],
          },
        },
      },
    },
    [VpEraseMethods.vpEnableEraseableGroup]: {
      label: '启用/禁用可被擦除分组',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
        },
        isEnable: {
          title: '启用/禁用',
          field: {
            options: [
              {
                label: '启用',
              },
              {
                label: '禁用',
              },
            ],
          },
        },
      },
    },
    [VpEraseMethods.vpPlayAllMovieClipForGroup]: {
      label: '显示并播放分组的全部序列帧',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
        },
      },
    },
    [VpEraseMethods.vpPauseAllMovieClipForGroup]: {
      label: '暂停播放分组的全部序列帧',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
        },
      },
    },
    [VpEraseMethods.vpPlayTweenForGroup]: {
      label: '播放分组的单个动画',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
        },
        vpTweenUuid: {
          title: '选择动画',
        },
      },
    },
    [VpEraseMethods.vpPauseTweenForGroup]: {
      label: '暂停播放分组的单个动画',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
        },
        vpTweenUuid: {
          title: '选择动画',
        },
      },
    },
    [VpEraseMethods.vpPlayTweenGoOnForGroup]: {
      label: '继续播放分组单个动画',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
        },
        vpTweenUuid: {
          title: '选择动画',
        },
      },
    },
    [VpEraseMethods.vpPlayAllTweenForGroup]: {
      label: '播放分组的全部动画',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
        },
      },
    },
    [VpEraseMethods.vpPauseAllTweenForGroup]: {
      label: '暂停播放分组的全部动画',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
        },
      },
    },
    [VpEraseMethods.vpPlayAllTweenGoOnForGroup]: {
      label: '继续播放分组的全部动画',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '响应对象',
        },
      },
    },
    [VpEraseMethods.vpReplaceHandImage]: {
      label: '替换跟手图片',
      category: VpCategories.erase,
      paramFormConfig: {
        handImage: {
          title: '跟手图片',
        },
      },
    },

    [VpBaseMethods.vpShakeScreen]: {
      label: '震屏效果',
      category: VpCategories.other,
      paramFormConfig: {
        duration: {
          title: '持续时长',
        },
        fequence: {
          title: '抖动频率',
        },
        xy: {
          title: '抖动最大距离',
        },
      },
    },
    [VpBaseMethods.vpCompute]: {
      label: '赋值',
      category: VpCategories.other,
      paramFormConfig: {
        target: {
          title: '全局变量',
        },
        method: {
          title: '运算方法',
        },
        value: {
          title: '运算数',
        },
      },
    },
    [VpBaseMethods.vpRetry]: {
      label: '重新试玩',
      category: VpCategories.other,
    },
    ...maskAction,
    ...carouselAction.carouselAction,
  },
  VpCategories,
}
